import React, { Component } from "react";

class ArticleIntro extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="content-row">
                    <div className="article-content">
                        {global.canUseDOM && isPageEditor && (
                            <div className="teaser__thumb__pageEditor">
                                <p>This image is only used on article list and archive pages</p>
                                <div
                                    className="teaser__thumb"
                                    dangerouslySetInnerHTML={{ __html: this.props.ArticleImage }}
                                />
                            </div>
                        )}
                        {this.props.TrumpetText && (
                            <span
                                className="content-trumpet"
                                dangerouslySetInnerHTML={{ __html: this.props.TrumpetText }}
                            ></span>
                        )}
                        {this.props.ArticleTitleText && (
                            <h1
                                className="content-header"
                                dangerouslySetInnerHTML={{ __html: this.props.ArticleTitleText }}
                            />
                        )}
                        <p className="article-intro__byline">
                            {this.props.ArticleDate && (
                                <span
                                    className="article-intro__byline__date"
                                    dangerouslySetInnerHTML={{ __html: this.props.ArticleDate }}
                                />
                            )}
                            {this.props.ArticleAuthorText && (
                                <span
                                    className="article-intro__byline__author"
                                    dangerouslySetInnerHTML={{ __html: this.props.ArticleAuthorText }}
                                />
                            )}
                        </p>
                        {this.props.ArticleShortDescription && (
                            <p
                                className="article-intro__lead content--intro-paragraph"
                                dangerouslySetInnerHTML={{ __html: this.props.ArticleShortDescription }}
                            ></p>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
export default ArticleIntro;
